import { useApi } from '../api/client.js';
import { Metric } from '../components/ui.js';
import { useAsync } from '../hooks/useAsync.js';

function formatNumber(n: number): string {
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

function formatPercent(fraction: number): string {
  return `${(fraction * 100).toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;
}

export function MetricsRow() {
  const api = useApi();
  const { state } = useAsync(() => api.metrics(), [api]);

  if (state.status === 'loading') {
    return <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="rounded-md px-4 py-3 animate-pulse"
          style={{ background: 'var(--bg-secondary)', height: 80 }}
        />
      ))}
    </div>;
  }

  if (state.status === 'error') {
    return (
      <div
        className="rounded-md px-4 py-3 text-[13px]"
        style={{ background: 'var(--danger-bg)', color: 'var(--danger-text)' }}
        role="alert"
      >
        Couldn't load metrics: {state.error.message}
      </div>
    );
  }

  const m = state.data;
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
      <Metric label="Sends, 7 days" value={formatNumber(m.sends7d)} />
      <Metric label="Clicks filtered" value={formatNumber(m.clicksFiltered7d)} />
      <Metric label="Filter rate" value={formatPercent(m.filterRate)} />
      <Metric label="Honeypot hits" value={formatNumber(m.honeypotHits7d)} />
      <Metric label="Bot clicks" value={formatNumber(m.botClicks7d ?? 0)} />
      <Metric label="Human confirmed" value={formatNumber(m.humanConfirmed7d ?? 0)} />
    </div>
  );
}
